import React, { useEffect, useState } from 'react'

import { transformBytes } from 'shared/utils'
import * as tus from 'tus-js-client'
import { Upload } from 'tus-js-client'

import classes from './FileItem.module.scss'

type Props = {
  idx: number
  file: File
  setFileError: (error: string) => void
  onLoadSuccess: (idx: number, tusName: string) => void
  onLoadError: () => void
  onDelete: (i: number) => void
}

export type LoadedFile = {
  fileName: string
  fileSize: number
  fileId: string
}

export const FileItem = ({
  idx,
  file,
  setFileError,
  onLoadSuccess,
  onLoadError,
  onDelete,
}: Props): JSX.Element | null => {
  const [tusUploadObj, setTusUploadObj] = useState<Upload>()
  const [uploadPercentage, setUploadPercentage] = useState(0)
  const [uploadStatus, setUploadStatus] = useState<
    'started' | 'finished' | 'failed' | ''
  >('')
  const [uploadError, setUploadError] = useState('')

  useEffect(() => {
    createTusUpload(file)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createTusUpload = (file: File) => {
    const upload = new tus.Upload(file, {
      endpoint: `/api/corpsite/v1/files/public/upload/`,
      removeFingerprintOnSuccess: true,
      chunkSize: 1000000,
      retryDelays: [0, 3000, 5000, 10000, 20000],
      metadata: {
        filename: file.name,
        filetype: file.type,
      },
      onError: error => {
        console.error({ error })
        setUploadStatus('failed')
        handleFileError('Ошибка загрузки')
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2)
        setUploadPercentage(Number(percentage))
      },
      onSuccess: () => {
        setUploadStatus('finished')
        let tusName = ''
        if (upload?.url) {
          const from = upload.url.lastIndexOf('/')
          const to = upload.url.indexOf('+')
          tusName = upload.url.substring(from + 1, to)
        }
        onLoadSuccess(idx, tusName)
      },
    })

    setTusUploadObj(upload)
    setUploadStatus('started')

    upload.start()
  }

  const handleFileError = (err: string) => {
    setUploadError(err)
    setFileError(err)
    onLoadError()
  }

  const renderContent = () => {
    const progressBar = (
      <div className={classes['files_item_progress']}>
        <span
          style={{
            width: `${uploadPercentage}%`,
          }}
        />
      </div>
    )
    const error = (
      <span className={classes['files_item_info--error']}>{uploadError}</span>
    )
    const size = (
      <span className={classes['files_item_info--size']}>
        {transformBytes(file.size)}
      </span>
    )

    return uploadStatus === 'started' ? (
      progressBar
    ) : (
      <>{uploadError.length ? error : size}</>
    )
  }

  const handleDelete = () => {
    if (uploadStatus === 'started' && tusUploadObj) {
      tusUploadObj.abort()
    }

    onDelete(idx)
  }

  const renderDelete = () => {
    return (
      <button
        className={`${classes.files_item_close} button_reset`}
        onClick={() => handleDelete()}
      >
        <i className="icon-close" />
      </button>
    )
  }

  return (
    <li className={classes.files_item}>
      <span className={classes.files_item_icon}></span>

      <div className={classes.files_item_info}>
        <small className={classes['files_item_info--name']}>{file?.name}</small>
        {renderContent()}
      </div>

      {renderDelete()}
    </li>
  )
}
